<template>
    
    <v-row align="center" class="my-16 rounded" style="background-color: #00B1C3; min-width: 400px">
        <v-col cols="12" md="2" align="center">
            <div>
                <h2 style="color: white;">OUR VALUES</h2>
            </div>
        </v-col>

        <v-col>
            <v-card elevation="2">
                <v-card-text>
                    <v-row
                        class="my-4"
                        align="center"
                        justify="center"
                    >
                        <h2>Our Values</h2>
                    </v-row>
                    <v-row
                        align="center"
                        justify="center"
                        class="mb-6"
                    >
                        <v-spacer></v-spacer>

                        <v-col
                            cols="8"
                            md="4"
                        >
                        <v-card flat>
                                <v-img
                                    src="@/assets/PDRT.jpg"
                                    aspect-ratio="1"
                                    width="400"
                                    alt="Prospira Values PDRT Logo"
                                ></v-img>
                            </v-card>
                        </v-col>

                        <v-spacer></v-spacer>

                        <v-col
                            cols="8"
                            md="4"
                        >
                            <v-card flat align="left">
                                <ul style="list-style-type: none;">
                                    <li class="my-2">
                                        <v-icon color="black" style="padding-right: 10px;">mdi-account</v-icon><strong style="color: #00B1C3;">P</strong>eople First   
                                    </li>

                                    <li class="my-2">
                                        <v-icon color="black" style="padding-right: 10px;">mdi-trending-up</v-icon><strong style="color: #00B1C3;">D</strong>ata Driven
                                    </li>

                                    <li class="my-2">
                                        <v-icon color="black" style="padding-right: 10px;">mdi-checkbox-marked-circle-outline</v-icon><strong style="color: #00B1C3;">R</strong>esults Oriented
                                    </li>
                                    
                                    <li class="my-2">
                                        <v-icon color="black" style="padding-right: 10px;">mdi-clock-fast</v-icon><strong style="color: #00B1C3;">T</strong>ime is of the Essence
                                    </li>
                                </ul>
                            </v-card>
                        </v-col>

                        <v-spacer></v-spacer>

                    </v-row>
                </v-card-text>
                
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
export default {
    name: 'OurValuesCard'
}
</script>

<style scoped>
    .title {
        border-radius: 100%;
        border: 3px solid #00B1C3;
        height: 150px;
        width: 150px;
    }
</style>